import { useCallback } from 'react';
import { MinusIcon } from '@i-ark/components';
import { resolveByPlatform } from '@i-ark/utils';
import { Button } from './atom.button.js';
import { jsx } from 'react/jsx-runtime';

function ZoomOutTool(props) {
  const handleClick = useCallback(evt => {
    evt.preventDefault();
    props.zoomOut();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.zoomOut]);
  if (!props.zoomEnabled) {
    return null;
  }
  return /*#__PURE__*/jsx(Button, {
    tooltip: "Zoom ud",
    shortcut: resolveByPlatform({
      win: "Ctrl+-",
      mac: "Cmd+-"
    }),
    onClick: handleClick,
    disabled: !props.zoomOutEnabled,
    children: /*#__PURE__*/jsx(MinusIcon, {
      size: 21
    })
  });
}

export { ZoomOutTool };
//# sourceMappingURL=tool.zoom-out.js.map
